import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-scissors': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 480c-45 0-77.3-43.3-64-85.9-21.6-13.7-34-38.8-30.3-65h-87.6c-40.8 0-74-32.8-74-73.1 0-40.3 33.2-73.1 74-73.1l94 9.1-78.8-18.7c-38.3-14.7-57-57.5-41.9-95.1 15-37.5 57.8-55.8 95.6-41.2l144.9 55.8c25-30.6 57.8-44 92.2-24.7l98 54.9c21 11.7 34 33.8 34 57.7v205.7c0 30.7-21.4 57.6-51.8 64.6l-119 27.4c-5 1.1-10.1 1.7-15.2 1.7zM256 432l70 0c1.2 0 3.2-0.2 4.4-0.5l119-27.4c8.6-2 14.6-9.3 14.6-17.8v-205.7c0-6.5-3.6-12.5-9.4-15.8l-98-54.9c-8.1-4.6-18.7-2.6-24.5 4.5l-21.8 26.6c-2.7 3.2-8.2 5.9-12.4 5.9-1.6 0-4.2-0.5-5.7-1.1l-166.5-64.1c-32.7-12.6-50.8 34.6-19.2 46.7l155.4 59.8c5.7 2.2 10.3 8.9 10.3 14.9v0 11.6c0 8.8-7.2 16-16 16h-182c-34.4 0-34.4 50.3 0 50.3h182c8.8 0 16 7.2 16 16v6.9c0 8.8-7.2 16-16 16h-28c-25.1 0-25.2 36.6 0 36.6h28c8.8 0 16 7.2 16 16v6.9c0 8.8-7.2 16-16 16-25.1 0-25.2 36.6 0 36.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-scissors.js
// module id = 1770
// module chunks = 0